<!-- loader -->
<div *ngIf="pageLoader" class="loader-bg">
  <div class="loadscreen flex">
    <div class="loader-center">
      <img src="assets/images/main-loading_logo.svg" class="logo mb-3" style="display: none" alt="">
      <div class="loader_container">
        <div class="item-1"></div>
        <div class="item-2"></div>
        <div class="item-3"></div>
        <div class="item-4"></div>
        <div class="item-5"></div>
      </div>
    </div>
  </div>
</div>
<!-- body -->
<div *ngIf="!pageLoader" class="auth-layout-wrap" [ngStyle]="{ 'background': commonService.vendor_login_info?.bg_color }">
  <div class="auth-content">
    <router-outlet (activate)="commonService.onActivate($event)"></router-outlet>
  </div>
  <footer>
    <div class="row w-100 m-0">
      <div class="col-md-12 px-0">
        <div class="yourstore-band p-3">
          <div class="yourstore-inner d-flex justify-content-end">
            <div class="d-flex justify-content-md-end justify-content-sm-center align-items-center col-md-4 px-0">
              <a href="/" class="yourstore-text d-flex align-items-center" target="_blank">
                <span class="px-0 float-left band-txt">Powered by</span>
                <span class="px-0 float-right">
                  <img width="100%" height="100%" src="assets/images/yourstore_logo.svg" class="yourstore-logo band-txt" alt="Yourstore">
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>     
    </div>
  </footer>
</div>